import { render } from "./PreRegistration.vue?vue&type=template&id=4a35cce2&ts=true"
import script from "./PreRegistration.vue?vue&type=script&lang=ts"
export * from "./PreRegistration.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/easowong/Documents/Codex/2026-10-04/referenced-chatgpt-conversation-this-is-an/work/lodash-20261025-213817-507f/frontend-candidate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__